import { IconPrinter, IconX } from "@tabler/icons-react";
import RaidoField from "../../../components/common/RaidoField";
import { useState } from "react";
import InputField from "../../../components/common/InputField";

type Props = {
  open: boolean;
  invoice?: any;
  onClose: () => void;
};

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex justify-between items-center w-full">
    <div className="w-full">
      <h2 className="capitalize text-[#212121] text-sm font-medium">{label}</h2>
    </div>
    <div className="w-full">
      <p className="text-[#1E293B] text-base">{value}</p>
    </div>
  </div>
);

const ViewModal = ({ open, invoice, onClose }: Props) => {
  const [mode, setMode] = useState("credit");

  if (!open) return null;

  const invId = invoice?.invoiceId || invoice?.id || "INV-001";
  const invAmount = invoice?.amount || "0 SAR";
  const invDueDate = invoice?.dueDate || "-";
  const invDescription = invoice?.description || "Invoice";

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl w-[655px]">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h1 className="text-2xl">Pay Invoice - {invId}</h1>
          <button
            onClick={onClose}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="w-full max-h-[520px] overflow-y-auto p-4 space-y-4">
          <InfoRow label="Invoice ID" value={invId} />
          <InfoRow label="Amount Due" value={invAmount} />
          <InfoRow label="Due Date" value={invDueDate} />
          <InfoRow label="Description" value={invDescription} />
          <div className="flex justify-between items-center w-full">
            <div className="w-full">
              <h2 className="text-base text-[#212121] font-medium">
                {" "}
                Need To Pay
              </h2>
            </div>
            <div className="w-full">
              <p className="text-lg text-[#212121] font-medium">{invAmount}</p>
            </div>
          </div>
          <RaidoField
            label="Payment Method"
            value={mode}
            onClick={(val) => {
              if (typeof val === "string") {
                setMode(val);
              }
            }}
            valuesArr={[
              { value: "credit", text: "Credit/Debit Card" },
              { value: "upi", text: "UPI / Paytm" },
              { value: "bank", text: "Bank Transfer" },
            ]}
          />
          {mode === "credit" && (
            <div className="grid grid-cols-2 gap-4">
              <InputField
                type="text"
                className="flex items-center col-span-2"
                label="Card Number"
                placeholder="985632147036522"
              />
              <InputField
                type="date"
                className="flex items-center"
                label="Expiry Date"
                placeholder={""}
              />
              <InputField
                type="text"
                className="flex items-center"
                label="CVV"
                placeholder="410"
              />
            </div>
          )}
          {mode === "upi" && (
            <div className="grid grid-cols-2 gap-4">
              <InputField
                type="text"
                className="flex items-center col-span-2"
                label="Enter UPI ID"
                placeholder="985632147036522"
              />
            </div>
          )}
          {mode === "bank" && (
            <div className="grid grid-cols-2 gap-4">
              <InputField
                type="text"
                className="flex items-center col-span-2"
                label="UTR/Reference No."
                placeholder="985632147036522"
              />
              <InputField
                type="text"
                className="flex items-center col-span-2"
                label="Billing Email (optional)"
                placeholder=" your@email.com"
              />
            </div>
          )}
        </div>

        <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-center">
          <button
            className="bg-[#FBD037] w-full rounded-full p-2  px-6 text-[#212121] text-base font-medium"
            onClick={onClose}
          >
            Pay 100 SAR
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
